var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    transform: "matrix(-1 0 0 1 40 0)",
    fill: "#002FA7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8457 20.0024L23.3286 15.6926C23.4521 15.5743 23.52 15.416 23.52 15.2472C23.52 15.0783 23.4521 14.9201 23.3286 14.8016L22.9358 14.4241C22.8126 14.3054 22.6478 14.24 22.4723 14.24C22.2967 14.24 22.1321 14.3054 22.0088 14.4241L16.6711 19.5553C16.5473 19.6742 16.4795 19.8332 16.48 20.0021C16.4795 20.1719 16.5472 20.3306 16.6711 20.4496L22.0038 25.5759C22.1272 25.6946 22.2917 25.76 22.4674 25.76C22.6429 25.76 22.8075 25.6946 22.9309 25.5759L23.3237 25.1984C23.5792 24.9527 23.5792 24.5528 23.3237 24.3073L18.8457 20.0024Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.db549a3a2540c6cc21854026829172cb.svg";
export { ForwardRef as ReactComponent };